import React from "react";
import Card from "react-bootstrap/Card";

export default class IndexScorerCard extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { currentContractor, defaultCompanyId } = this.props;

    return (
      <Card body>
        <div className="p">Have a question?</div>
        <div className="p large">
          <a href="https://docs.google.com/document/d/19M4nOtK_dFKzZHSroA5KQep1NenXMnh2NpTc4B8byu4/edit">
            Read the FAQ.
          </a>
        </div>
        {currentContractor.qualified_companies_count > 0 && (
          <div>
            <br />
            <a href={`contractor_users/${currentContractor.id}/training`}>
              Training
            </a>
          </div>
        )}
        <br />
        <a href={"/contractor_users/" + currentContractor.id}>
          View your profile
        </a>
        <br />
        <br />
        <div className="h3 large">Helpful resources</div>
        <ul>
          <li>
            <a href={"/contractor_users/" + defaultCompanyId + "/qa_overview"}>
              Overview
            </a>
          </li>
          <li>
            <a href="https://docs.google.com/document/d/1sMPnNNwyuMq1IsDU-12cT-74JUAx3J9A3lg5sFZfHOA/edit?usp=drivesdk">
              QA Rating Guidelines
            </a>
          </li>
          <li>
            <a href="/privacy_policies">Privacy Policies</a>
          </li>
        </ul>
        <br />
        <a href="/contractor_users/logout">Logout</a>
      </Card>
    );
  }
}
